import { render, staticRenderFns } from "./info-alert-box.vue?vue&type=template&id=df638f80&scoped=true"
import script from "./info-alert-box.vue?vue&type=script&lang=js"
export * from "./info-alert-box.vue?vue&type=script&lang=js"
import style0 from "./info-alert-box.vue?vue&type=style&index=0&id=df638f80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df638f80",
  null
  
)

export default component.exports